var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogTitle = void 0;
var DialogTitle_1 = __importDefault(require("./DialogTitle"));
exports.DialogTitle = DialogTitle_1.default;
exports.default = DialogTitle_1.default;
//# sourceMappingURL=index.js.map